exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-carte-js": () => import("./../../../src/pages/carte.js" /* webpackChunkName: "component---src-pages-carte-js" */),
  "component---src-pages-cave-js": () => import("./../../../src/pages/cave.js" /* webpackChunkName: "component---src-pages-cave-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

